<div class="mail" [ngClass]="currentState()" [class.is-disabled]="disabled()">
  <div class="mail-container">
    <input class="mail-input" type="email" [(ngModel)]="value" [placeholder]="placeholder()" [name]="name()" [disabled]="disabled()" (blur)="onBlur()">
  </div>
  @if (alert() && currentState() !== fieldState.Default) {
    <div class="mail-alert">
      <ui-inline-svg class="mail-alert-icon" [name]="icon()"></ui-inline-svg>
      <span class="mail-alert-text">{{ alert() }}</span>
    </div>
  }
</div>
